import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnseenCommentsIconComponent } from './unseen-comments-icon/unseen-comments-icon.component';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { UnseenCommentsListComponent } from './unseen-comments-list/unseen-comments-list.component';
import { ZalamoElementNameModule } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/zalamo-element-name/zalamo-element-name.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LuxonModule } from 'luxon-angular';
import { OrganizationMemberModule } from 'ZalamoLibrary/src/lib/ui/organization-member/organization-member.module';
import { CommentsModule } from 'ZalamoLibrary/src/lib/ui/comments/comments.module';
import { SmartPreviewModule } from 'ZalamoLibrary/src/lib/ui/smart-preview/smart-preview.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [UnseenCommentsIconComponent, UnseenCommentsListComponent],
  imports: [
    CommonModule,
    ButtonModule,
    MatBadgeModule,
    MatIconModule,
    ZalamoElementNameModule,
    MatTooltipModule,
    LuxonModule,
    OrganizationMemberModule,
    CommentsModule,
    SmartPreviewModule,
    RouterModule,
  ],
  exports: [UnseenCommentsIconComponent, UnseenCommentsListComponent],
})
export class UnseenCommentsIconModule {}
